import { useTheme } from '@mui/material';
import { RegularText } from '../../../../../../app/components';
import { ClipboardButton, ClipboardContainer } from './styles';
import ClipboardIco from 'assets/icons/ClipboardIco';

export interface IClipboardProps {
  code: string;
}

const Clipboard = ({ code }: IClipboardProps) => {
  const theme = useTheme();
  return (
    <ClipboardContainer>
      <RegularText>{code}</RegularText>
      <ClipboardButton>
        <ClipboardIco color={theme.palette.brand.primary.base as string} />
      </ClipboardButton>
    </ClipboardContainer>
  );
};

export default Clipboard;
